import { useEffect } from 'react';
import { Routes, Route, Outlet, useNavigate } from 'react-router-dom';
import { FundNowViewResponsive } from './pages/FundNowViewResponsive';
import { ActivateFundNow } from './pages/ActivateFundNow';
import { DealConfirmation } from './pages/DealConfirmation';
import { ConfirmDetails } from './pages/ConfirmDetails';
import { ExceededLimit } from './pages/ExceededLimit';
import { DealSuccess } from './pages/DealSuccess';
import { DealSummary } from './pages/DealSummary';
import { InvoicePdfViewer } from './pages/InvoicePdfViewer';
import {
    ApplicationPending,
    ProductPaused,
    DealPending,
    ProductPending,
    ApplicationRejected,
    Waitlist,
} from '@lendica/components';
import { useFundnowApi } from './api';
import { useLocation } from 'react-router-dom';
import { useCompanyNavigate } from '@lendica/hooks';

export const FundNow = () => {
    const navigate = useCompanyNavigate();
    const api = useFundnowApi();
    const location = useLocation();

    const activate = async () => {
        try {
            await api.activateFundnow();
            navigate('/fundnow');
        } catch (e) {
            console.log(e);
        }
    };

    // When on waitlisted/paused/pending routes, re-evaluate on company switch and redirect accordingly
    useEffect(() => {
        const path = location.pathname;
        const isGuarded = /\/fundnow\/(waitlist|product-pending|product-paused)(\/)?$/.test(path);
        if (!isGuarded) return;
        let cancelled = false;
        (async () => {
            try {
                const company = await api.getCompanyDetail();
                if (cancelled) return;
                if (company.status === 2) {
                    if (company.fundnow_status === 0) {
                        // stay on waitlist
                        return;
                    }
                    if (company.fundnow_status === 1) {
                        navigate('/fundnow/product-pending');
                        return;
                    }
                    if (company.fundnow_status === 3) {
                        navigate('/fundnow/product-paused');
                        return;
                    }
                    navigate('/fundnow');
                } else {
                    navigate('/fundnow');
                }
            } catch (_e) {
                // noop
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [api, location.pathname, navigate]);

    return (
        <Routes>
            <Route path="*" element={<FundNowViewResponsive />} />
            <Route path="deal/:id" element={<DealSummary />} />
            <Route path="activate" element={<ActivateFundNow />} />
            <Route path="deal-pending" element={<DealPending />} />
            <Route path="application-rejected" element={<ApplicationRejected />} />
            <Route path="product-pending" element={<ProductPending />} />
            <Route path="pending" element={<ApplicationPending />} />
            <Route path="exceeded-limit" element={<ExceededLimit />} />
            <Route path="product-paused" element={<ProductPaused />} />
            <Route path="waitlist" element={<Waitlist product="FundNow" callback={activate} />} />
            <Route path=":type/:id/confirm" element={<ConfirmDetails />} />
            <Route
                path=":type/:id/terms"
                element={
                    <>
                        <Outlet />
                        <InvoicePdfViewer collapsible />
                    </>
                }
            >
                <Route path="select" element={<DealConfirmation />} />
                <Route path="confirmation/:dealId" element={<DealSuccess />} />
            </Route>
        </Routes>
    );
};
